import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  FetchStudBookHorseByOwnerBreederthunk,
  FetchStudBookHorseByOwnerthunk,
} from "../Redux/StudBook/StudBookAction";
import {
  emptyPage,
  incrementPageOwnerDetails,
  resetSearch,
} from "../Redux/StudBook/StudBookSlice";
import { useTranslate } from "../components/TranslationText";
import Loader from "../components/Loader";
import HorseCard from "../components/HorseCard";
import { FetchOwnerStudDataByIdthunk } from "../Redux/OwnerProfile/OwnerProfileAction";
import SectionTitle from "../components/SectionTitle";
import NewActionButton from "../components/ActionButtons/NewActionButton";
import { iconContainer, noDataCard, showIconsContainer } from "../common/cssclasses";

const OwnerDetailsPage = () => {
  const dispatch = useDispatch();

  const ownerData = useRef({});

  ownerData.current = useLocation().state;

  const {
    studBookLoading,
    studBookOwnerDetailsData,
    stateShowMoreButtonHorse,
    totalCountOwnerDetails,
    pageOwnerDetails,
    take,
    currentLanguage,
    studBookOwnerDetailsStateNoDataFound,
  } = useSelector((state) => state.studBookSlice);

  const { ownerStudData } = useSelector((state) => state.ownerProfileSlice);
  const { translate } = useTranslate();

  const [HorsesOwnedActive, setHorsesOwnedActive] = useState(true);
  const [HorsesBredsActive, setHorsesBredsActive] = useState(false);

  const [selectedSearchType, setSelectedSearchType] = useState(1);

  const navigate = useNavigate();

  const handleSelectedSearchType = (e) => {
    setSelectedSearchType(e);
    dispatch(resetSearch());
  };

  useEffect(() => {
    if (pageOwnerDetails === 0) {
      dispatch(emptyPage());
      return;
    }

    let params = {
      ownerId: !!ownerData.current && ownerData.current.id,
      skip: (pageOwnerDetails - 1) * take,
      take,
      langauge: currentLanguage,
    };
    if (selectedSearchType === 1) {
      dispatch(FetchStudBookHorseByOwnerthunk(params));
    }
    if (selectedSearchType === 2) {
      dispatch(FetchStudBookHorseByOwnerBreederthunk(params));
    }
  }, [pageOwnerDetails, currentLanguage, ownerData.current]);

  useEffect(() => {
    if (!!ownerData.current && ownerData.current.id) {
      dispatch(FetchOwnerStudDataByIdthunk({ id: ownerData.current.id }));
    }
  }, [ownerData.current]);

  // Derived data from the new API
  const ownerInfo = ownerStudData?.owner;
  const studInfo = ownerStudData?.stud;
  const studList = ownerStudData?.studList ?? [];
  const ownerType = ownerStudData?.ownerType; // "Owner" or "Stud"
  const isStud = ownerType !== "Owner";

  // Determine display name and header
  const displayName = isStud
    ? (studInfo?.name || ownerData?.current?.name)
    : (ownerInfo?.name || ownerData?.current?.name);

  const horsesOwned = isStud
    ? (studInfo?.numberofHorsesOwned ?? ownerData?.current?.numberofHorsesOwned ?? 0)
    : (ownerInfo?.numberofHorsesOwned ?? ownerData?.current?.numberofHorsesOwned ?? 0);

  const horsesBred = isStud
    ? (studInfo?.numberofHorsesBred ?? ownerData?.current?.numberofHorsesBred ?? 0)
    : (ownerInfo?.numberofHorsesBred ?? ownerData?.current?.numberofHorsesBred ?? 0);

  const regNo = isStud
    ? (studInfo?.regNo || ownerData?.current?.ownerId)
    : (ownerInfo?.regNo || ownerData?.current?.ownerId);

  const nationality = isStud
    ? (studInfo?.nationality || ownerData?.current?.nationality)
    : (ownerInfo?.nationality || ownerData?.current?.nationality);

  const handelShowMore = async () => {
    dispatch(incrementPageOwnerDetails());
  };

  return (
    <React.Fragment>
      <>
        <div className="row   rtl ">
          {/* Header: Display Name */}
          <h2 className="col-lg-6 col-md-6 col-sm-12  text-start bold rtl capatalise">
            {displayName}
          </h2>

          {/* Secondary name (owner name when viewing a stud) */}
          {isStud && ownerInfo &&
            <h4 className="col-lg-6 col-md-6 col-sm-12  text-md-end text-start bold rtl capatalise C89C66">
              {ownerInfo.name}
            </h4>
          }

          {/* Reg No & Nationality */}
          <div className={showIconsContainer}>
            <div className={iconContainer}>
              <i className="fa fa-user C89C66"></i>
              <span>
                {translate("web.regno", "regno")} {regNo}
              </span>
            </div>
            {!!nationality &&
              <div className={iconContainer}>
                <i className="fa-solid fa-earth-americas C89C66"></i>
                <span>
                  {nationality}
                </span>
              </div>
            }
          </div>

          {/* Stud Buttons Section */}
          <div className="col-md-12 col-sm-12 rtl">
            {/* When viewing a Stud: show "Explore Owner Horses" link */}
            {isStud && ownerInfo &&
              <div
                className="btn btn-outline-danger mb-main"
                onClick={() => {
                  navigate("/ownerdetails", {
                    state: {
                      id: ownerInfo.id,
                      name: ownerInfo.name,
                      numberofHorsesBred: ownerInfo.numberofHorsesBred,
                      numberofHorsesOwned: ownerInfo.numberofHorsesOwned,
                      nationality: ownerInfo.nationality,
                      ownerId: ownerInfo.regNo,
                    },
                  });
                }}
              >
                {translate('web.exploreOwnerHorses', 'Explore Owner Horses')}
              </div>
            }

            {/* When viewing an Owner: show list of stud buttons in one row */}
            {!isStud && studList.length > 0 &&
              <div className="d-flex flex-wrap gap-2 mb-main">
                {studList.map((stud, i) => (
                  <div
                    key={stud.id || i}
                    className="btn btn-outline-danger"
                    onClick={() => {
                      navigate("/ownerdetails", {
                        state: {
                          id: stud.id,
                          name: stud.name,
                          numberofHorsesBred: stud.numberofHorsesBred,
                          numberofHorsesOwned: stud.numberofHorsesOwned,
                          nationality: stud.nationality,
                          ownerId: stud.regNo,
                        },
                      });
                    }}
                  >
                    {stud.regNo} - {stud.name} ({translate(`web.${stud.studType}`, stud.studType)})
                  </div>
                ))}
              </div>
            }
          </div>

          {/* Section Title */}
          <div className="col-md-12 col-sm-12 rtl">
            {ownerStudData &&
              <SectionTitle
                ish3
                noMargin
                isContainer={false}
                section_name={isStud
                  ? translate('web.studHorses', 'Stud Horses')
                  : translate('web.ownerHorses', 'Owner Horses')
                }
              />
            }
          </div>

          {/* Tabs: Horses Owned / Horses Bred */}
          <div
            className={'col-6  text-center pe-0 mb-main'}
            style={{ cursor: 'pointer' }}
            id="second_most_used_services"
            onClick={() => {
              setHorsesOwnedActive(true);
              setHorsesBredsActive(false);
              handleSelectedSearchType(1);
            }}
          >
            <span className={`${HorsesOwnedActive ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>
              {translate("web.horsesOwned", "Horses Owned")} {horsesOwned}
            </span>
            <div className="service_bar_underline" style={HorsesOwnedActive ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
          </div>
          <div
            className={'col-6 text-center ps-0 mb-main'}
            style={{ cursor: 'pointer' }}
            id="second_most_used_services"
            onClick={() => {
              setHorsesOwnedActive(false);
              setHorsesBredsActive(true);
              handleSelectedSearchType(2);
            }}
          >
            <span className={`${HorsesBredsActive ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 15 }}>
              {translate("web.horsesBreds", "horsesBreds")} {horsesBred}
            </span>
            <div className="service_bar_underline" style={HorsesBredsActive ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
          </div>

          {/* Horse Cards */}
          {!!studBookOwnerDetailsData &&
            studBookOwnerDetailsData.length > 0 &&
            studBookOwnerDetailsData.map((item, i) => (
              <HorseCard isArabicClass={true} item={item} i={i} />
            ))}

          {studBookOwnerDetailsStateNoDataFound && (
            <div className="col-12">
              <div className={noDataCard}>
                {translate("web.nodataFound", "No Data Found !")}
              </div>
            </div>
          )}

          <div
            className="col-lg-12 col-md-12 col-sm-12 text-center row"
          >
            {!studBookLoading &&
              !!studBookOwnerDetailsData &&
              studBookOwnerDetailsData.length > 0 ? (
              <div className="mx-auto w-unset">
                <NewActionButton
                  disabled={stateShowMoreButtonHorse}
                  onClick={handelShowMore}
                  text={`
                        ${translate("web.showMore", "Show More")} (${studBookOwnerDetailsData.length
                    } ${translate("web.of", "Of")} ${totalCountOwnerDetails})`}
                />
              </div>
            ) : (
              ""
            )}
            {studBookLoading && <Loader />}
          </div>
        </div>
      </>
    </React.Fragment>
  );
};

export default OwnerDetailsPage;
